import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import {
  getMasomoSmartDownloadUrl,
  getWonyapaySmartDownloadUrl,
  WONYAPAY_APP_DOWNLOAD_PATH,
  MASOMO_ANDROID_STORE_URL,
  MASOMO_IOS_STORE_URL,
  MASOMO_MACOS_STORE_URL,
  MASOMO_WINDOWS_STORE_URL,
  WONYAPAY_ANDROID_STORE_URL,
  WONYAPAY_IOS_STORE_URL,
  WONYAPAY_MACOS_STORE_URL,
  WONYAPAY_WINDOWS_STORE_URL,
} from '../constants/links';
import { useLanguage } from '../i18n/LanguageProvider';

const StoreRedirect = ({ application }) => {
  const { t } = useLanguage();
  const name = application === 'masomo' ? 'Masomo' : 'WonyaPay';
  const destination = application === 'masomo'
    ? getMasomoSmartDownloadUrl()
    : getWonyapaySmartDownloadUrl();
  const isStore = destination !== WONYAPAY_APP_DOWNLOAD_PATH;
  const manualStores = application === 'masomo'
    ? [MASOMO_ANDROID_STORE_URL, MASOMO_IOS_STORE_URL, MASOMO_MACOS_STORE_URL, MASOMO_WINDOWS_STORE_URL]
    : [WONYAPAY_ANDROID_STORE_URL, WONYAPAY_IOS_STORE_URL, WONYAPAY_MACOS_STORE_URL, WONYAPAY_WINDOWS_STORE_URL];

  useEffect(() => {
    if (isStore) window.location.replace(destination);
  }, [destination, isStore]);

  return (
    <section className="ws-section" data-no-i18n="true">
      <div className="ws-shell ws-section-heading ws-section-heading--center">
        <span className="ws-kicker">{name}</span>
        <h1>{t('Télécharger')} {name}</h1>
        <p role={isStore ? 'status' : undefined}>{t(isStore ? 'Ouverture du store de votre appareil…' : 'Sélectionnez votre système pour télécharger l’application.')}</p>
        <div className="ws-button-row">
          {isStore ? (
            <a className="ws-button ws-button--primary" href={destination}>
              {t('Ouvrir le store')}
              <ArrowUpRight size={18} aria-hidden="true" />
            </a>
          ) : manualStores.map((url, index) => (
            <a className="ws-button ws-button--primary" key={url} href={url}>
              {t(['Android', 'iPhone et iPad', 'macOS', 'Windows'][index])}
              <ArrowUpRight size={18} aria-hidden="true" />
            </a>
          ))}
          <Link className="ws-button ws-button--secondary" to={WONYAPAY_APP_DOWNLOAD_PATH}>
            {t('Nos applications')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default StoreRedirect;
